/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryAccountDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryAccountDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryAccountDetail>): ComplianceAssessmentSummaryAccountDetail {
        let obj = Object.assign(new ComplianceAssessmentSummaryAccountDetail(), model);
        ComplianceAssessmentSummaryAccountDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryAccountDetail>): ComplianceAssessmentSummaryAccountDetail {
        if (!model) return null;
        return ComplianceAssessmentSummaryAccountDetail.newInstance(<ComplianceAssessmentSummaryAccountDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryAccountDetail) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryAccountDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryAccountDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryAccountDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.standards) {
            for (let val of this.standards) {
                models.ComplianceAssessmentSummaryStandardDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * List of standards with their policy IDs
     */
    standards: Array<models.ComplianceAssessmentSummaryStandardDetail>;

}
